// S0: dedicated namespace for paper trading config (main file at 1486/1500).
export const tradingMessagesEn = {
    "widget.trading.settingsTitle": "Paper Trading Settings",
    "widget.trading.commissionRate": "Broker fee (%)",
    "widget.trading.taxRate": "Sell tax (%)",
    "widget.trading.slippageTicks": "Slippage (ticks)",
    "widget.trading.costBasisMethod": "Cost basis method",
    "widget.trading.fifo": "FIFO (first in - first out)",
    "widget.trading.weightedAverage": "Weighted average",
    "widget.trading.leverage": "Max leverage",
    "widget.trading.allowShortSelling": "Allow short selling",
    "widget.trading.integrityFailureMode": "On trading problem",
    "widget.trading.integrityMode_warn": "Warn only",
    "widget.trading.integrityMode_block": "Block new orders",
    "widget.trading.integrityMode_strict": "Reject silently",
    "widget.trading.integrityMode_warn_hint": "Keep trading, but show a warning",
    "widget.trading.integrityMode_block_hint": "Stop new orders until you review the problem",
    "widget.trading.integrityMode_strict_hint": "Treat the bad order as invalid data and drop it without a notice",
    "widget.trading.integrityFailureModeHint": "Applies when saving fails or incoming price data is unusable. It controls how much you are told and how much is locked — the underlying data is already protected either way.",
    "widget.trading.persistFailedToast": "Could not save your trading state — recent changes may be lost on reload",
    "widget.trading.barRejectedToast": "{count} price update(s) were unusable and were ignored",
    "widget.trading.settlementDays": "Settlement cycle",
    "widget.trading.perChartOverride": "Apply only to this chart pane",
    "widget.trading.unknownMarket": "Unclassified symbol — temporarily using VN_SPOT rules (Lot 100, T+2).",
    "widget.trading.openSettings": "Open Settings",
    "widget.trading.quickMode": "Quick (market only)",
    "widget.trading.position": "Position",
    "widget.trading.unrealizedPnl": "Unrealized P&L",
    "widget.trading.stopTypeHint": "Stop-market: when price touches the stop level, the order fills at market (stop-market). Stop-limit (trigger + limit price) isn't supported yet.",
    "widget.trading.reviewTitle": "Confirm order",
    "widget.trading.orderValue": "Order value",
    "widget.trading.pnlGross": "Gross",
    "widget.trading.pnlNet": "Net",
    "widget.trading.pnlNetHint": "Net = after fees and slippage",
    "widget.trading.tabFees": "Fees",
    "widget.trading.tabExec": "Execution",
    "widget.trading.tabPnl": "Basis",
    "widget.trading.tabRules": "Rules",
    "widget.trading.fifoShort": "FIFO",
    "widget.trading.resetDefaults": "Reset to defaults",
    "widget.trading.commissionFixed": "Flat commission (per contract)",
    "widget.trading.pnlDisplayMode": "PnL display mode",
    "widget.trading.orderRejected": "Order rejected: {side} {quantity} {symbol} ({code})",
    // The 7 OrderRejectCode values (src/lib/core/trading/types.ts). HistoryTab
    // used to render the raw enum ("Rejected (INSUFFICIENT_BUYING_POWER)"),
    // putting a technical string on screen and making it untranslatable.
    "widget.trading.rejectCode.UNSUPPORTED_TIF": "Unsupported time-in-force",
    "widget.trading.rejectCode.UNSUPPORTED_ORDER_TYPE": "Unsupported order type",
    "widget.trading.rejectCode.INSUFFICIENT_BUYING_POWER": "Insufficient buying power",
    "widget.trading.rejectCode.INVALID_QUANTITY": "Invalid quantity",
    "widget.trading.rejectCode.INVALID_PRICE": "Invalid price",
    "widget.trading.rejectCode.SHORT_NOT_ALLOWED": "Short selling not allowed",
    "widget.trading.rejectCode.PRICE_OUT_OF_BAND": "Price outside the allowed band",
};
